import { useState, useEffect } from "react";
import { site } from "@/mocks/site-data";

export default function Preloader() {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(true);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    let raf: number;
    let start = 0;
    const duration = 2400;

    const step = (timestamp: number) => {
      if (!start) start = timestamp;
      const elapsed = timestamp - start;
      const next = Math.min((elapsed / duration) * 100, 100);
      setProgress(next);

      if (next < 100) {
        raf = requestAnimationFrame(step);
      } else {
        setTimeout(() => {
          setFading(true);
          setTimeout(() => setVisible(false), 700);
        }, 400);
      }
    };

    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background-50 transition-opacity duration-700 ${fading ? "opacity-0" : "opacity-100"}`}
      aria-hidden={fading}
    >
      <div className="w-56 overflow-hidden px-4 md:w-72">
        <div
          className="h-px bg-accent-400 transition-[width] duration-100 ease-linear"
          style={{ width: `${progress}%` }}
        />
      </div>

      <h1
        className={`mt-8 px-4 text-center font-heading text-xl font-normal tracking-[0.28em] text-foreground-50 transition-opacity duration-700 md:text-3xl ${progress > 10 ? "opacity-100" : "opacity-0"}`}
      >
        {site.name}
      </h1>

      <p
        className={`mt-3 px-4 text-[10px] uppercase tracking-[0.3em] text-accent-400 transition-opacity duration-700 md:text-xs ${progress > 25 ? "opacity-100" : "opacity-0"}`}
      >
        Medicina estética
      </p>

      <div
        className={`mt-6 h-px w-24 bg-foreground-50/15 transition-opacity duration-700 md:w-32 ${progress > 50 ? "opacity-100" : "opacity-0"}`}
      />
    </div>
  );
}